<!--
 * @Description: 
 * @Author: liXinMan
 * @Date: 2021-12-28 13:53:21
 * @LastEditors: liXinMan
 * @LastEditTime: 2021-12-30 14:22:28
-->
<template>
	<div id="app">
		<div>
			<audio id="audio" autoplay="autoplay" loop>
				<source src="./assets/music-bg.mp3" type="audio/mpeg" />
			</audio>
		</div>
		<router-view />
	</div>
</template>

<script>
export default {
	data() {
		return {}
	},
	watch: {
		$play(val) {
			console.log('====================================')
			console.log(val)
			console.log('====================================')
		}
	}
}
</script>

<style lang="stylus">
body {
  margin: 0;
  padding: 0;
}

.el-message-box {
  max-width: 100vw;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 14px;
  width: 100vw;
}
</style>
